import ErrorAddBank from "@components/CreateQuoteForm/ErrorAddBank";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGetCurrentBankQuery } from "store/bank/bank.api";
import { useGetClientsQuery } from "store/client/clientApi";
import {
  useCreateInvoiceMutation,
  useGetInvoiceByCompanyAndIdQuery,
  useGetNextInvoiceNumberQuery,
  useUpdateInvoiceMutation,
} from "store/invoice/invoiceApi";
import { useGetOffersQuery } from "store/offer/offerApi";
import { useGetUserByIdQuery } from "store/user/userApi";

export const useCreateInvoiceHook = () => {
  const navigate = useNavigate();
  const [dureeEcheance, setDureeEcheance] = useState(30); // valeur par défaut à 30 jours

  const currentUser = useSelector((state) => state.auth.user);

  const companyId = currentUser?.companyId?._id;
  const invoiceId = currentUser?.invoiceId || "";
  const getDeviseSymbol = (devise) => (devise === "USD" ? "$" : "€");
  const { data, isLoading, error } = useGetInvoiceByCompanyAndIdQuery(
    { companyId, invoiceId },
    { skip: !companyId || !invoiceId }
  );
  const { data: currentBankData, isLoading: isLoadingBankData } =
    useGetCurrentBankQuery(companyId);

  const [articleLines, setArticleLines] = useState([
    {
      description: "",
      quantity: 0,
      price: 0,
      TVA: 0,
      reduction: 0,
      TotalHt: 0,
      devise: "EUR",
      deposit: 0,
      idOffer: "",
      reductionPercent: 0,
      reductionAmount: 0,
    },
  ]);
  const { data: dataUser } = useGetUserByIdQuery(currentUser?._id, {
    skip: !currentUser?._id,
  });
  const [totals, setTotals] = useState({
    subtotal: 0,
    discountAmount: 0,
    finalHT: 0,
    tva: 0,
    ttc: 0,
  });

  const [extraInputs, setExtraInputs] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [numeroInvoice, setNumeroInvoice] = useState("");

  // TODO: update notes get response from api
  const [note, setNote] = useState("");
  const [engagementId, setEngagementId] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("");
  const [dateEcheance, setDateEcheance] = useState("");
  const [dateDeFacturation, setDateDeFacturation] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [currency, setCurrency] = useState("EUR");

  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientAddress, setClientAddress] = useState("");

  const [sellerName, setSellerName] = useState(currentUser?.name || "");
  const [sellerEmail, setSellerEmail] = useState(currentUser?.email || "");
  const [sellerAddress, setSellerAddress] = useState(
    currentUser?.address || ""
  );
  useEffect(() => {
    setNote(dataUser?.data?.companyId?.note || "");
    setPaymentTerms(dataUser?.data?.companyId?.payment_method || "");
  }, [dataUser]);
  const calculateInvoiceTotals = (lines) => {
    const totals = lines.reduce(
      (acc, line) => {
        const lineTotal = (line.price || 0) * (line.quantity || 1);
        const reduction =
          (lineTotal * (line.reductionPercent || 0)) / 100 +
          (line.reductionAmount || 0);
        const lineHT = lineTotal - reduction;
        const lineTVA = (lineHT * (line.TVA || 0)) / 100;

        return {
          subtotal: acc.subtotal + lineHT, // ← ligne HT après réduction
          discountAmount: acc.discountAmount + reduction,
          tva: acc.tva + lineTVA,
          ttc: acc.ttc + lineHT + lineTVA,
        };
      },
      { subtotal: 0, discountAmount: 0, tva: 0, ttc: 0 }
    );

    return {
      ...totals,
      finalHT: totals.subtotal, // ✅ plus besoin de retrancher la réduction
    };
  };

  // const { name, iban, bic } = currentBankData?.data;
  const [paymentInfo, setPaymentInfo] = useState({
    bankName: "",
    iban: "",
    bic: "",
    rib: "",
  });
  useEffect(() => {
    if (currentBankData?.data) {
      setPaymentInfo({
        bankName: currentBankData.data.name || "",
        iban: currentBankData.data.iban || "",
        bic: currentBankData.data.bic || "",
        rib: currentBankData.data.rib || "",
      });
    }
  }, [currentBankData]);
  useEffect(() => {
    if (currentUser) {
      setNote(currentUser?.companyId?.note);
      setPaymentTerms(currentUser?.companyId?.payment_method);
    }
  }, [currentUser]);

  const [createInvoice, { isLoading: isCreating }] = useCreateInvoiceMutation();
  const [updateInvoice, { isLoading: isUpdating }] = useUpdateInvoiceMutation();

  const { data: nextInvoiceData, isLoading: isLoadingNextNumber } =
    useGetNextInvoiceNumberQuery(currentUser?.companyId?._id, {
      skip: !currentUser?.companyId?._id,
    });

  const {
    data: offersResponse,
    isLoading: isLoadingOffers,
    error: offersError,
  } = useGetOffersQuery(companyId, {
    skip: !companyId,
  });

  const {
    data: companiesResponse,
    isLoading: isLoadingCompanies,
    error: companiesError,
  } = useGetClientsQuery(companyId);
  const companiesData = companiesResponse?.data || [];
  console.log("🚀 ~ companiesData:", companiesData);
  const clientsData = selectedCompanyId
    ? companiesData.find((c) => c._id === selectedCompanyId)?.userClients || []
    : [];

  console.log("🚀 ~ clientsData:", clientsData);
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = reorder(
      articleLines,
      result.source.index,
      result.destination.index
    );
    setArticleLines(reordered);
  };
  const totalReduction = articleLines.reduce((sum, line) => {
    // Calculate the reduction amount for each line
    const quantity = Number(line.quantity) || 0;
    const price = parseFloat(line.price) || 0;
    const reduction = parseFloat(line.reduction) || 0;
    let lineTotal = quantity * price;
    let reductionAmount = 0;
    if (reduction > 0) {
      reductionAmount = lineTotal * (reduction / 100);
    }
    return sum + reductionAmount;
  }, 0);
  const getInvoicePreviewData = () => {
    const safeTotals = totals || {
      subtotal: 0,
      discountAmount: 0,
      finalHT: 0,
      tva: 0,
      ttc: 0,
    };

    return {
      numeroInvoice:
        numeroInvoice || nextInvoiceData?.data?.numeroInvoice || "",
      dateDeFacturation,
      sellerName,
      sellerAddress,
      clientName,
      clientAddress,
      clientEmail,
      offers: articleLines,
      totalHT: safeTotals.finalHT,
      taxTVA: safeTotals.tva,
      total: safeTotals.ttc,
      devise: currency || "EUR",
      engagementId,
      note,
      deposit: totalReduction,
      offersResponse: offersResponse?.data || [],
      extraInputs,
      companyName: currentUser?.companyId?.name,
    };
  };

  const handleLineChange = (index, fieldOrFields, maybeValue) => {
    const newLines = [...articleLines];

    if (typeof fieldOrFields === "string") {
      newLines[index][fieldOrFields] = maybeValue;
    } else if (typeof fieldOrFields === "object" && fieldOrFields !== null) {
      newLines[index] = {
        ...newLines[index],
        ...fieldOrFields,
      };
    }

    const quantity = parseFloat(newLines[index].quantity) || 0;
    const price = parseFloat(newLines[index].price) || 0;
    const reductionPercent = parseFloat(newLines[index].reductionPercent) || 0;

    if (
      (typeof fieldOrFields === "string" &&
        ["reductionPercent", "price", "quantity"].includes(fieldOrFields)) ||
      (typeof fieldOrFields === "object" &&
        ["reductionPercent", "price", "quantity"].some(
          (f) => f in fieldOrFields
        ))
    ) {
      const reductionAmount = (price * quantity * reductionPercent) / 100;
      newLines[index].reductionAmount = Number(reductionAmount.toFixed(2));
    }

    const reductionAmount = parseFloat(newLines[index].reductionAmount) || 0;
    const totalHT = price * quantity - reductionAmount;
    newLines[index].TotalHt = Number(totalHT.toFixed(2));

    const tvaRate = parseFloat(newLines[index].TVA) || 0;
    const tvaAmount = totalHT * (tvaRate / 100);
    newLines[index].TotalTTC = Number((totalHT + tvaAmount).toFixed(2));

    // Recalcul global
    const subtotal = newLines.reduce(
      (sum, line) =>
        sum + (parseFloat(line.price) || 0) * (parseFloat(line.quantity) || 0),
      0
    );

    const totalReduction = newLines.reduce(
      (sum, line) => sum + (parseFloat(line.reductionAmount) || 0),
      0
    );

    const finalHT = subtotal - totalReduction;

    const tva = newLines.reduce((sum, line) => {
      const qty = parseFloat(line.quantity) || 0;
      const prc = parseFloat(line.price) || 0;
      const rdc = parseFloat(line.reductionAmount) || 0;
      const lineHT = prc * qty - rdc;
      return sum + (lineHT * (parseFloat(line.TVA) || 0)) / 100;
    }, 0);

    const ttc = finalHT + tva;

    const normalizedLines = newLines.map((line) => ({
      ...line,
      quantity: Number(line.quantity) || 0,
      price: Number(line.price) || 0,
    }));

    setArticleLines(normalizedLines);

    setTotals({
      subtotal: Number(subtotal.toFixed(2)),
      discountAmount: Number(totalReduction.toFixed(2)),
      finalHT: Number(finalHT.toFixed(2)),
      tva: Number(tva.toFixed(2)),
      ttc: Number(ttc.toFixed(2)),
    });
  };

  const handleAddLine = () => {
    setArticleLines([
      ...articleLines,
      {
        description: "",
        quantity: 1,
        price: 0,
        TVA: 0,
        reduction: 0,
        TotalHt: 0,
        devise: "EUR",
      },
    ]);
  };

  const handleRemoveLine = (index) => {
    setArticleLines(articleLines.filter((_, i) => i !== index));
  };

  const handleCompanyChange = (companyId) => {
    setSelectedCompanyId(companyId);
    setSelectedClientId("");
    setClientName("");
    setClientEmail("");
    setClientAddress("");
  };

  const handleExtraInputChange = (index, field, val) => {
    const updated = [...extraInputs];
    updated[index][field] = val;
    setExtraInputs(updated);
  };

  const handleAddExtraInput = () => {
    setExtraInputs([...extraInputs, { label: "", value: "" }]);
  };

  const handleRemoveExtraInput = (index) => {
    setExtraInputs(extraInputs.filter((_, i) => i !== index));
  };

  const handleCreateInvoice = async (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    const filteredExtraInputs = extraInputs.filter(
      (input) => input.label.trim() !== "" && input.value.trim() !== ""
    );

    try {
      const invoiceData = {
        companyId: currentUser?.companyId?._id,
        clientId: selectedCompanyId,
        offers: articleLines,
        typeDocument: "invoice",
        type: "sell",
        invoiceStatus: "A valider", // statut à valider
        dateDeFacturation: dateDeFacturation,
        dateEcheance: dateEcheance
          ? new Date(dateEcheance).toISOString()
          : undefined,
        engagementId: engagementId || undefined,

        rib: currentUser?.companyId?.rib,
        totalHT: Number(totals?.subtotal || 0),
        taxTVA: Number(totals?.tva || 0),
        total: Number(totals?.ttc || 0),
        devise: currency || "EUR",
        deposit: totals.discountAmount,

        clientName,
        clientAddress,
        dureeEcheance: dureeEcheance,

        clientEmail,
        sellerName,
        sellerAddress,
        sellerEmail,
        paymentInfo,
        paymentTerms,
        extraInputs: filteredExtraInputs,
        note,
        idbank: currentBankData?.data?._id,
      };

      const response = await createInvoice(invoiceData).unwrap();
      setNumeroInvoice(response.numeroInvoice);

      toast.success("Facture créée avec succès!");
      setTimeout(() => {
        navigate("/invoicesList");
      }, 1500);
    } catch (err) {
      console.error("Failed to create invoice:", err);
      console.log("🚀 ~ handleClick ~ err:", err);

      const messagesToCheck = [
        "idbank must be a mongodb id",
        "rib must be a string",
      ];

      const errorMessages = err?.data?.message || [];

      const hasBankError = errorMessages.some((msg) =>
        messagesToCheck.includes(msg)
      );

      if (hasBankError) {
        toast.error(<ErrorAddBank />);
      } else {
        toast.error(
          err?.data ? err?.data?.message[0] : "Problem when creating devis"
        );
      }
    }
  };
  useEffect(() => {
    console.log("⏱️ dureeEcheance changée:", dureeEcheance);
    if (!dateDeFacturation) return;
    const factureDate = new Date(dateDeFacturation);
    factureDate.setDate(factureDate.getDate() + Number(dureeEcheance));
    setDateEcheance(factureDate.toISOString().split("T")[0]);
  }, [dateDeFacturation, dureeEcheance]);

  useEffect(() => {
    if (!data?.data || !data?.data?.offers) return;

    const invoice = data.data;

    const lines = invoice.offers.map((line) => {
      const quantity = line.quantity || 0;
      const price = line.idOffer?.price || 0;
      const reductionPercent = Number(line.reductionPercent) || 0;
      const reductionAmount = Number(line.reductionAmount) || 0;

      const lineTotal = price * quantity;
      const reduction = (lineTotal * reductionPercent) / 100 + reductionAmount;
      const totalHtAfterReduction = lineTotal - reduction;

      return {
        name: line?.idOffer?.name || "",
        description: line?.idOffer?.description || "",
        quantity,
        price,
        TVA: line.TVA ?? line.idOffer?.tva ?? 0,
        reductionPercent,
        reductionAmount,
        TotalHt: Number(totalHtAfterReduction.toFixed(2)),
        idOffer: line.idOffer?._id || "",
      };
    });
    // recalculer les totaux
    const computedTotals = calculateInvoiceTotals(lines);
    setTotals(computedTotals);

    // autres champs optionnels à hydrater si besoin (facultatif ici)
    setClientName(invoice.clientName || "");
    setClientEmail(invoice.clientEmail || "");
    setClientAddress(invoice.clientAddress || "");
    setSellerName(invoice.sellerName || "");
    setSellerEmail(invoice.sellerEmail || "");
    setSellerAddress(invoice.sellerAddress || "");
    setNote(invoice.note || "");
    setDateDeFacturation(invoice.dateDeFacturation?.split("T")[0] || "");
    setDateEcheance(invoice.dateEcheance?.split("T")[0] || "");
    setEngagementId(invoice.engagementId || "");
    setSelectedCompanyId(
      typeof invoice.companyId === "object"
        ? invoice.companyId._id
        : invoice.companyId || ""
    );
    setSelectedClientId(
      typeof invoice.clientId === "object"
        ? invoice.clientId._id
        : invoice.clientId || ""
    );
    console.log("✅ Données de la facture (data):", data);
  }, [data]);
  const handleSaveDraft = async () => {
    try {
      const filteredExtraInputs = extraInputs.filter(
        (input) => input.label.trim() !== "" && input.value.trim() !== ""
      );

      const invoiceData = {
        companyId: selectedCompanyId || "",
        clientId: selectedClientId || "",
        offers: articleLines,
        typeDocument: "invoice",
        type: "sell",
        invoiceStatus: "Brouillon", // statut brouillon forcé
        dateDeFacturation: dateDeFacturation,
        dateEcheance: dateEcheance
          ? new Date(dateEcheance).toISOString()
          : undefined,
        engagementId: engagementId || undefined,
        rib: currentUser?.companyId?.rib,
        totalHT: Number(totals?.subtotal || 0),
        taxTVA: Number(totals?.tva || 0),
        total: Number(totals?.ttc || 0),
        devise: currency || "EUR",
        deposit: totals.discountAmount,

        clientName,
        clientAddress,
        dureeEcheance: dureeEcheance,

        clientEmail,
        sellerName,
        sellerAddress,
        sellerEmail,
        paymentInfo,
        paymentTerms,
        extraInputs: filteredExtraInputs,
        note,
      };

      const response = await createInvoice(invoiceData).unwrap();
      setNumeroInvoice(response.numeroInvoice);

      toast.success("Brouillon sauvegardé avec succès!");
      setTimeout(() => {
        navigate("/invoicesList");
      }, 1500);
    } catch (err) {
      console.error("Échec de la sauvegarde du brouillon:", err);
      toast.error("Échec de la sauvegarde du brouillon");
    }
  };

  return {
    articleLines,
    setArticleLines,
    totals,
    setTotals,
    extraInputs,
    setExtraInputs,
    companiesData,
    clientsData,
    offersResponse,
    nextInvoiceData,
    isLoadingNextNumber,
    selectedCompanyId,
    setSelectedCompanyId,
    selectedClientId,
    setSelectedClientId,
    clientName,
    setClientName,
    clientEmail,
    setClientEmail,
    clientAddress,
    setClientAddress,
    sellerName,
    setSellerName,
    sellerEmail,
    setSellerEmail,
    sellerAddress,
    setSellerAddress,
    note,
    setNote,
    paymentTerms,
    setPaymentTerms,
    dateEcheance,
    setDateEcheance,
    dateDeFacturation,
    setDateDeFacturation,
    currency,
    setCurrency,
    engagementId,
    setEngagementId,
    paymentInfo,
    setPaymentInfo,
    isCreating,
    isLoadingOffers,
    isLoadingCompanies,
    offersError,
    companiesError,

    handleLineChange,
    handleAddLine,
    handleRemoveLine,
    handleCompanyChange,
    handleExtraInputChange,
    handleAddExtraInput,
    handleRemoveExtraInput,
    handleCreateInvoice,
    handleDragEnd,
    getInvoicePreviewData,
    navigate,
    currentUser,
    companyId,
    showPreview,
    setShowPreview,
    updateInvoice,
    getDeviseSymbol,
    calculateInvoiceTotals,
    dureeEcheance,
    setDureeEcheance,
    handleSaveDraft,
    isLoadingBankData,
  };
};
